import { render, staticRenderFns } from "./ModalKanbanAdditional.vue?vue&type=template&id=73190a5c&"
import script from "./ModalKanbanAdditional.vue?vue&type=script&lang=js&"
export * from "./ModalKanbanAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports